import { apiGet, apiSend } from './client';
import type { AuthMeResponse } from './types';

export async function fetchAuthMe() {
  return apiGet<AuthMeResponse>('/auth/me');
}

export async function logout() {
  return apiSend<{ loggedOut: boolean }>('/auth/logout', 'POST');
}
